import React from 'react';
import { Flex, Image, Text } from '@chakra-ui/react';
import { theme } from '#config';

export const InstallationCell = ({ installation }) => {
  const { profile, status } = installation;

  return (
    <Flex justifyContent="space-between" width="full" alignItems="center">
      <Flex>
        <Image
          src={profile.avatarUrl}
          boxSize={5}
          borderRadius="full"
          marginRight={2}
        />
        <Text fontSize="sm">
          {profile.name}
        </Text>
      </Flex>
      {status !== 'ACTIVE' && status !== 'SYNCING' && <CircleMarker size={8} />}
    </Flex>
  );
};

const CircleMarker = ({ size }) => (
  <svg
    data-testid="circle-marker"
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
  >
    <circle cx={size / 2} cy={size / 2} r={size / 2} fill={theme.colors.orange[500]} />
  </svg>
);
